import { useState, useRef } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import VideoSection from "./components/VideoSection";
import PainSection from "./components/PainSection";
import EducationSection from "./components/EducationSection";
import DifferenceSection from "./components/DifferenceSection";
import NoDemolitionSection from "./components/NoDemolitionSection";
import BeforeAfterSection from "./components/BeforeAfterSection";
import CostSection from "./components/CostSection";
import TrustSection from "./components/TrustSection";
import UrgencySection from "./components/UrgencySection";
import ContactFormSection from "./components/ContactFormSection";
import FooterSection from "./components/FooterSection";
import InspectionModal from "./components/InspectionModal";
import FloatingContact from "./components/FloatingContact";
import { useFadeIn } from "@/hooks/useFadeIn";

function FadeSection({ children }: { children: React.ReactNode }) {
  const { ref, visible } = useFadeIn();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
    >
      {children}
    </div>
  );
}

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);
  const educationRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);

  const handleLearnClick = () => {
    educationRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleAssessmentClick = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-[#0a0e1a]">
      <Navbar onInspectionClick={() => setModalOpen(true)} />

      <HeroSection
        onInspectionClick={() => setModalOpen(true)}
        onLearnClick={handleLearnClick}
      />

      <FadeSection>
        <VideoSection />
      </FadeSection>

      <FadeSection>
        <PainSection />
      </FadeSection>

      <div ref={educationRef}>
        <FadeSection>
          <EducationSection />
        </FadeSection>
      </div>

      <FadeSection>
        <DifferenceSection />
      </FadeSection>

      <FadeSection>
        <NoDemolitionSection />
      </FadeSection>

      <FadeSection>
        <BeforeAfterSection />
      </FadeSection>

      <FadeSection>
        <CostSection onInspectionClick={() => setModalOpen(true)} />
      </FadeSection>

      <FadeSection>
        <TrustSection />
      </FadeSection>

      <FadeSection>
        <UrgencySection
          onInspectionClick={() => setModalOpen(true)}
          onAssessmentClick={handleAssessmentClick}
        />
      </FadeSection>

      <div ref={contactRef}>
        <FadeSection>
          <ContactFormSection />
        </FadeSection>
      </div>

      <FooterSection onInspectionClick={() => setModalOpen(true)} />

      <FloatingContact onInspectionClick={() => setModalOpen(true)} />
      <InspectionModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
